<template>
  <option
    :value="value"
    class="select__option"
    tabindex="0"
  >
    <slot />
  </option>
</template>
<script>

export default {
  name: 'SelectOption',
  props: {
    value: {
      type: [String, Number, Object],
      default: '',
    },
  },
};

</script>
